import { ARTICLE_LINKS_LIMIT, SearchArticleLinksParams } from '@/redux/modules/articleLinks/articleLinks.types';
import { ItemFacets } from '@/types/ItemFacets';
import { getCategoryLevels } from '@/utils/categoryGrabber';

export const getItemArticleLinksParams = (facets?: ItemFacets): SearchArticleLinksParams | undefined => {
    const brand = facets?.creators?.[0]?.l1CategoryName;
    if (brand) {
        return { brand, searchLimit: ARTICLE_LINKS_LIMIT };
    }

    const category = facets?.categories?.[0] && getCategoryLevels(facets.categories[0]).at(-1)?.categoryName;
    if (category) {
        return { category, searchLimit: ARTICLE_LINKS_LIMIT };
    }

    return undefined;
};
